<div class="dashboard-placeholder test-class">
    <p>Welcome to SL Video API Management Portal. Click on navigation bar to begin.</p>
</div>

